import { FormattedMessage } from "react-intl";
import StepLabel from "../StepLabel";
import { PaymentMethodCard, PaymentMethodCardContainer } from "../../styles";
import { BallotIcon, CardIcon, QRCode } from "../../../components/Icons";
import { useEffect } from "react";
import { useFormContext } from "./form-context";

const paymentMethodsList = [
  {
    id: "card",
    action: "F1",
    text: <FormattedMessage id="card" />,
  },
  {
    id: "pix",
    action: "F2",
    text: "pix",
  },
  {
    id: "cash",
    action: "F3",
    text: <FormattedMessage id="cash" />,
  },
];

export function PaymentMethods() {
  const { selectedPaymentMethodError } = useFormContext();
  return (
    <>
      <StepLabel
        number={1}
        text={"select_payment_method"}
        error={selectedPaymentMethodError}
      />
      <PaymentMethodCardContainer>
        {paymentMethodsList.map((method) => (
          <PaymentMethod
            key={method.id}
            text={method.text}
            id={method.id}
            action={method.action}
          />
        ))}
      </PaymentMethodCardContainer>
    </>
  );
}

function PaymentMethod({ text, id, action }) {
  const {
    selectedPaymentMethod,
    selectedPaymentMethodError,
    setSelectPaymentMethod,
    setSelectedPaymentMethodError,
  } = useFormContext();

  const selected = selectedPaymentMethod === id;

  const iconMap = new Map();
  iconMap.set("cash", <BallotIcon color={selected ? "#068ec3" : "#62748E"} />);
  iconMap.set("pix", <QRCode color={selected ? "#068ec3" : "#62748E"} />);
  iconMap.set("card", <CardIcon color={selected ? "#068ec3" : "#62748E"} />);

  const Icon = iconMap.get(id);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === action.toString()) {
        event.preventDefault();
        setSelectPaymentMethod(id);
        setSelectedPaymentMethodError(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [action, id, setSelectPaymentMethod, setSelectedPaymentMethodError]);

  return (
    <PaymentMethodCard
      onClick={() => {
        setSelectPaymentMethod(id);
        setSelectedPaymentMethodError(false);
      }}
      error={selectedPaymentMethodError}
      selected={selected}
    >
      <div>
        {Icon}
        <span>{text}</span>
      </div>
      <span>{action}</span>
    </PaymentMethodCard>
  );
}
